import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = ({ className, onLinkClick }) => {
  const handleClick = () => {
    if (onLinkClick) {
      onLinkClick();
    }
  };

  // Scroll with custom offset for each section
  const scrollWithOffset = (offset) => (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: yCoordinate + offset, behavior: 'smooth' }); 
  };

  return (
    <div className={className}>
      <HashLink
        className="px-4 text-xl font-extrabold text-white hover:text-green-300 drop-shadow-lg transition-colors duration-300"
        smooth
        to="/#about"
        scroll={scrollWithOffset(-175)}
        onClick={handleClick}
      >
        About Us
      </HashLink>
      <HashLink
        className="px-4 text-xl font-extrabold text-white hover:text-green-300 drop-shadow-lg transition-colors duration-300"
        smooth
        to="/#volunteer"
        scroll={scrollWithOffset(-235)}
        onClick={handleClick}
      >
        Volunteer
      </HashLink>
      <HashLink
        className="px-4 text-xl font-extrabold text-white hover:text-green-300 drop-shadow-lg transition-colors duration-300"
        smooth
        to="/#events"
        scroll={scrollWithOffset(-235)}
        onClick={handleClick}
      >
        Upcoming Events
      </HashLink>
      <HashLink
        className="px-4 text-xl font-extrabold text-white hover:text-green-300 drop-shadow-lg transition-colors duration-300"
        smooth
        to="/#donations"
        scroll={scrollWithOffset(-175)}
        onClick={handleClick}
      >
        Donations
      </HashLink>
    </div>
  );
};

export default NavLinks;